/**
 * SubscribersReportsCtrl controller
 *
 * @class SubscribersReportsCtrl
 * @memberof mwApp/subscribersReports
 * @see mwApp/subscribersReports
 * @mixes mwApp/common.mixin:tabsCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/subscribersReports.controller:SubscribersReportsCtrl
 */

/* @ngInject */
export default function SubscribersReportsCtrl ($scope, authSvc) {
  var vm = this
  vm.mixes = authSvc.hasAccess('createCpsReport')
    ? [['tabsCtrlMixin', '', 'generated_reports']]
    : [['tabsCtrlMixin', '']]

  /**
   * Methods to change tab
   *
   * @memberof mwApp/reports.controller:SubscribersReportsCtrl
   */
  vm.toChangeTab = function (tabName) {
    $scope.$broadcast(`dispatch: ${tabName}`)
  }
}
